import {Component, EventEmitter, Input, OnChanges, Output, ViewEncapsulation} from '@angular/core';
import { HubPlace } from 'models/hub/hub.place';
import { config } from '../../../../../config/config';
import { HubPlaceAdditionalData } from '../../../../models/hub/hub.google.place.data';
import { HubVisitorFeatureToggle } from '../../../../models/hub/hub.visitor.feature.toggle';
import { ConfigService } from '../../../../services/config.service';

@Component({
    selector: 'ig-place-map-section',
    templateUrl: './place.map.section.component.html',
    styleUrls: ['./place.map.section.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class PlaceMapSectionComponent {
    @Input() public place: HubPlace;
    @Input() public hubName: string;
    @Input() public mapZoom = 16;
    @Input() public isAccommodation = false;
    @Input() public featuresToggle = new HubVisitorFeatureToggle();
    @Input() public googlePlaceAdditionalData: HubPlaceAdditionalData;
    @Input() public hideIconMapStyler = ConfigService.config.google.hideMapBusinessIconStyles;

    public allPlaces = [];

    @Output() onGotoPlace: EventEmitter<any> = new EventEmitter();
    @Output() onGotoWebsite: EventEmitter<any> = new EventEmitter();
    @Output() onGetDirection: EventEmitter<any> = new EventEmitter();

    constructor() {
    }

    public getDirection() {
        this.onGetDirection.emit();
        let address = this.place.address.address || this.place.address;
        let url = config.eventShare.googleMapGetDirection
            .replace('${address}', encodeURIComponent(address.toString()));
        window.open(url, '_blank');
    }

    public visitWebsite() {
        this.onGotoWebsite.emit();
        if (this.place.website || this.place.hostLink) {
            window.open(this.place.website || this.place.hostLink, '_blank');
        } else if (this.googlePlaceAdditionalData && this.googlePlaceAdditionalData.website) {
            window.open(this.googlePlaceAdditionalData.website, '_blank');
        }
    }
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/visitor/place.details.modal/place.map.section.component/place.map.section.component.ts